export default () => ({
    root: {
        display: "block",
        position: "absolute",
        left: "calc(50vw - 21px)",
        top: "50vh",
    }
});